



import React from 'react';
import bannerImage from "../img/banner/online-robotics.jpg"; 
import './BtnPage.css';
import brochure from '../img/TOOL & FIXURE DESIGN BROCHURE V3.pdf';

const Outdoor = () => {
  return (
    <div className="hero-area overly-style-1 opacity-point-4">

      <img
        className="banner-image  bddgh"
        src={bannerImage}
        alt="About AA Applications Banner"
        style={{ width: '100%', height: '530px' }}
      />

      <div style={{ color: '#fff', position: 'absolute', top: '100px', textAlign: 'left' }} className='about-databanner'>


        <h1 style={{ fontWeight: '700', padding: '10px',color:'black',marginLeft:'70px',fontSize:'40px' }} className="bannerhead">
          Certification on <span style={{ fontSize: '40px', color: '#fb9100',fontSize:'50px' }}>Digital Factory Solution</span>
        </h1>



        <div style={{ marginLeft: '60px' }}>
          {/* <p style={{ textAlign: 'left', fontSize: '30px', fontWeight: '900',color:'black' ,marginLeft:'19px'}}>We Provide :</p> */}

          <ul style={{ fontSize: '20px', fontWeight:"600" }}>
            <li  style={{color:'black'}}>Discover the future of facilities management through digital transformation. </li>
            <li style={{color:'black'}}>Master the integration of Scan-to-3D, BIM, and point cloud technologies.</li>
            <li style={{color:'black'}}>Gain hands-on expertise in implementing advanced digital solutions.</li>
            <li style={{color:'black'}}>Learn to optimize modern facilities with precise, data-driven methods.</li>
            <li style={{color:'black'}}>Enhance operational efficiency and cost management using innovative tools. </li>
            <li style={{color:'black'}}>Prepare for a thriving career in smart infrastructure and digital facility management.  </li>
          </ul>
        </div>

        <div
          className="enroll-download-buttons d-flex flex-column flex-md-row justify-content-center align-items-center buttondownbrochure endbrd"
          style={{ width: '72%' }}
        >
          <div className="col-auto">
            <button
              type="button"
              className="btn brittle ps-4 pe-4 custom-button"
              style={{ marginTop: '20px', backgroundColor: 'black' }}
            >
              <a href="https://dashboard.iiautomate.com/" style={{ color: 'white' }} target='blank'>Enroll now</a>

            </button>
          </div>
          <div className="col-auto">
            <button
              type="button"
              className="btn brittle  ps-4 pe-4 custom-button"
              style={{ marginTop: '20px', backgroundColor: 'black' }}
              onClick={() => {
                const link = document.createElement('a');
                link.href = brochure;
                link.download = 'Brochure.pdf';
                link.click();
              }}
            >
              Download Brochure
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Outdoor;
